import { LanguageCode } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';
import { getLanguagePropertiesFromCountryCode } from '../../../utils/languages';

/** Every language, named in English. */
export const LANGUAGE_FILTER_OPTIONS: FilterOption<LanguageCode>[] = Object.values(LanguageCode).map((code) => ({
  value: code,
  label: getLanguagePropertiesFromCountryCode(code).name
}));
